import {Link as MuiLink, TableCell, TableCellProps} from "@mui/material";
import {Link} from "react-router-dom";
import {CellContent} from "./types";
import {EMPTY_UI} from "../../variables";
import {tableRowBackground} from "./Background";

type CustomTableCellProps = Omit<TableCellProps, "content"> & {
    content: string | CellContent;
    link?: string;
    align?: "left" | "center" | "right";
    rowIndex?: number;
    index?: number;
    sticky?: boolean;
    selectableRows?: boolean;
    width?: number;
};

export default function CustomTableCell({
    content,
    link,
    align = "left",
    rowIndex,
    index,
    sticky,
    selectableRows,
    width,
}: CustomTableCellProps) {
    let columnContent: any;
    switch (typeof content) {
        case "object":
            columnContent = content?.node;
            break;
        case "string":
            columnContent = content.trim();
            break;
        default:
            columnContent = content;
    }
    const columnTitle = typeof content === "object" ? content?.title : columnContent;
    columnContent = columnContent || EMPTY_UI;
    return (
        <TableCell
            align={align}
            sx={{
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                pl: index === 0 ? 5 : 2,
                ...(sticky ? {position: "sticky", zIndex: 3, background: "white", left: selectableRows ? 42 : 0} : {}),
                backgroundColor: tableRowBackground(rowIndex),
                maxWidth: width,
            }}
            title={columnTitle}
        >
            {link ? (
                <MuiLink component={Link} to={link}>
                    {columnContent}
                </MuiLink>
            ) : (
                columnContent
            )}
        </TableCell>
    );
}
